module.exports = __webpack_public_path__ + "img/direct-normal.01329c54.svg";